var React = require('react');

function PhoneAndroid (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","fillRule":"evenodd","key":1})]);
}

PhoneAndroid.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 24"};

module.exports = PhoneAndroid;

PhoneAndroid.default = PhoneAndroid;
